export const QUERY_SIGNED_DOCUMENT_LIST = "QUERY_SIGNED_DOCUMENT_LIST";
export const QUERY_SIGNED_DOCUMENT = "QUERY_SIGNED_DOCUMENT";

// templates
export const QUERY_SIGNED_DOCUMENT_TEMPLATE_LIST =
  "QUERY_SIGNED_DOCUMENT_TEMPLATE_LIST";
export const QUERY_SIGNED_DOCUMENT_TEMPLATE = "QUERY_SIGNED_DOCUMENT_TEMPLATE";
